import React, { useEffect } from "react";
import { Radio } from "@mantine/core";
import { useForm, Controller } from "react-hook-form";

const ClaimDetails = ({ onSubmit, setSteptwo, claimData }) => {
  const {
    control,
    watch,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      type_of_claim: "", // Initialize as empty
    },
  });

  // Valid claim types from API that match our radio options
  const validClaimTypes = [
    "delayed",
    "cancelled",
    "denied_boarding",
    "lost/damaged",
    "other",
  ];

  // Check if API claim type matches our options
  const apiClaimType = validClaimTypes.includes(claimData?.type_of_claim)
    ? claimData.type_of_claim
    : "";

  const type_of_claim = watch("type_of_claim");

  // Load initial value from API or localStorage
  useEffect(() => {
    // First priority: API data if valid
    if (apiClaimType) {
      setValue("type_of_claim", apiClaimType, { shouldValidate: true });
      setSteptwo(true);
      localStorage.setItem("claimType", apiClaimType);
    }
    // Second priority: localStorage
    else {
      const savedClaimType = localStorage.getItem("claimType");
      if (savedClaimType && validClaimTypes.includes(savedClaimType)) {
        setValue("type_of_claim", savedClaimType, { shouldValidate: true });
        setSteptwo(true);
      } else {
        // Ensure form starts empty if no valid value exists
        reset({ type_of_claim: "" });
        setSteptwo(false);
      }
    }
  }, [apiClaimType, setValue, reset, setSteptwo]);

  // Save to localStorage whenever the claim type changes
  useEffect(() => {
    if (type_of_claim && validClaimTypes.includes(type_of_claim)) {
      localStorage.setItem("claimType", type_of_claim);
    }
  }, [type_of_claim]);

  // Handle form submission
  const handleFormSubmit = (data) => {
    console.log("Form data submitted:", data);
    localStorage.setItem("claimType", data.type_of_claim);
    onSubmit(data);
  };

  return (
    <div className="select-claim-type stepper-container">
      <h3 className="stepper-header">Claim details</h3>
      <form onSubmit={handleSubmit(handleFormSubmit)} id="claim-details-form">
        <div>
          <h4 className="stepper-sub-header">
            What happened to your flight?
            <span style={{ color: "red" }}> *</span>
          </h4>
          <div className="radio-options-wrapper">
            <Controller
              name="type_of_claim"
              control={control}
              rules={{ required: "Please select an option" }}
              render={({ field }) => (
                <Radio.Group
                  value={field.value}
                  onChange={(value) => {
                    field.onChange(value);
                    setSteptwo(!!value); // Enable next button when a value is selected
                  }}
                >
                  <Radio
                    color="red"
                    variant="outline"
                    value="delayed"
                    label="Flight delayed (3+ hours)"
                  />
                  <Radio
                    color="red"
                    variant="outline"
                    value="cancelled"
                    label="Flight cancelled (Not applicable if alternative flight was provided by Airline)"
                  />
                  <Radio
                    color="red"
                    variant="outline"
                    value="denied_boarding"
                    label="Denied boarding"
                  />
                  <Radio
                    color="red"
                    variant="outline"
                    value="lost/damaged"
                    label="Lost/damaged/delayed baggage"
                  />
                  <Radio
                    color="red"
                    variant="outline"
                    value="other"
                    label="Other issue"
                  />
                </Radio.Group>
              )}
            />
            {errors.type_of_claim && (
              <p style={{ color: "red", marginTop: "10px" }}>
                {errors.type_of_claim.message}
              </p>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default ClaimDetails;
